import $ from 'jquery';
import { has } from 'lodash';
import { PaymentCalculatorFactory } from '@dealersites/dealersite-js-core';
import { formatPrice } from '@oem-theme/utilities.js';

const $site = $('.site');
const FREQUENCY = $site.data('frequency')

const formatSrpPrice = formatPrice.custom(['srp', 'nasapi']);

const dsp = (global.dsp = global.dsp || {});
const apiCalls = new Map();

function getIncentives(itemId) {
  if (!apiCalls.has(itemId)) {
    apiCalls.set(itemId, dsp.incentives.fetch(itemId));
  }

  return apiCalls.get(itemId);
}

export function runNasapi() {
  if (dsp.incentives) {
    $('.nasapi-vehicle-card').each(async function () {
      const $card = $(this);
      const $payments = $card.find('.nasapiPayment');

      if ($payments.length) {
        try {
          const itemID = $card.data('item-id');
          const incentives = await getIncentives(itemID).catch(() => {});

          if (!has(incentives, 'finance.value') && !has(incentives, 'lease.value')) {
            $card.find('.dsp-finance').each(function () {
              showElem($(this));
            });
            $card.find('.dsp-lease').each(function () {
              showElem($(this));
            });
            $card.find('.payment-loader').each(function () {
              $(this).remove();
            });
            return;
          }
          try {
          if (has(incentives, 'finance.value')) {
            handleFinance(incentives.finance, $card.find('.nasapi-finance'), itemID);
          } else {
            $card.find('.dsp-finance').each(function () {
              showElem($(this));
            });
          }
        } catch (err) {
          throw "finance"
        } finally {

        }

        try {
          if (has(incentives, 'lease.value')) {
            handleLease(incentives.lease, $card.find('.nasapi-lease'), itemID);
          } else {
            $card.find('.dsp-lease').each(function () {
              showElem($(this));
            });
          }
          $card.find(".payment-loader").each(function () {
            $(this).remove();
          });
        } catch (err) {
          throw "lease";
        } finally {

        }

          $card.find('.payment-loader').each(function () {
            $(this).remove();
          });

        } catch (type) {


          $card.find(`.dsp-${type}`).each(function () {
            showElem($(this));
          });
          $card.find('.payment-loader').each(function () {
            $(this).remove();
          });
        }
      } else {
        $card.find('.dsp-finance').each(function () {
          showElem($(this));
        });

        $card.find('.dsp-lease').each(function () {
          showElem($(this));
        });
        $card.find('.payment-loader').each(function () {
          $(this).remove();
        });
      }
    });
  }
}

export function handleFinance(finance, $elem, item, disclaimer = null) {

  const terms = [];
  let price = 0;
  let disclaimerDetails = '';
  let totalFinanceIncentives = 0;
  let $payment = {};

  if ($elem) {
    $payment = $elem.find('.js-payment');
    price = $payment.data('price');
  } else {
    price = item.lowest_price;
  }

  if (disclaimer) {
    disclaimerDetails = disclaimer;
  } else {
    disclaimerDetails = $payment.data('disclaimer-details');
  }

  const values = finance.value;
  for (let key in values) {
    terms.push(values[key]);
  }

  terms.sort((a, b) => (a.value < b.value ? 1 : -1));
  terms.sort((a, b) => (a.from < b.from ? 1 : -1));
  const setTerms = terms[0];


  if (finance.cash) {
    const financeIncentives = finance.cash;
    for (let key in financeIncentives) {
      totalFinanceIncentives += financeIncentives[key].value;
    }
  }

  price = price - totalFinanceIncentives;

  let calcInputs = {
    price: price,
    down: 0,
    term: setTerms.from,
    rate: setTerms.value,
    tradein: 0,
    tax: 0,
  };


  if (disclaimerDetails.adjustPayments) {
    calcInputs.tax = parseInt(disclaimerDetails.tax);
  }

  const newCalc = PaymentCalculatorFactory.createCalculator('finance', calcInputs);

  newCalc.calculate();
  const finalPayment = newCalc.payments[FREQUENCY];
  if ($elem) {
    $payment.text(formatSrpPrice(finalPayment));
    showElem($elem);
  } else {
    return finalPayment;
  }
}

export function handleLease(lease, $elem, item, disclaimer = null) {

  const terms = [];
  const values = lease.value;
  let price = 0;
  let disclaimerDetails = '';
  let $payment = {};
  let residualPrice = 0;

  if ($elem) {
    $payment = $elem.find('.js-payment');
    price = $payment.data('price');
    residualPrice = $payment.data('residual-price');
  } else {
    price = item.lowest_price;
    residualPrice = item.price;
  }


  if (disclaimer) {
    disclaimerDetails = disclaimer;
  } else {
    disclaimerDetails = $payment.data('disclaimer-details');
  }


  for (let key in values) {
    terms.push(values[key]);
  }

  terms.sort((a, b) => (a.value < b.value ? 1 : -1));
  terms.sort((a, b) => (a.from < b.from ? 1 : -1));
  const setTerms = terms[0];

  const residualAmount = residualPrice * (setTerms.residual_value / 100);

  if (residualAmount) {

    let totalLeaseIncentives = 0;
    if (lease.cash.length) {
      const leaseIncentives = lease.cash;
      leaseIncentives.forEach(function (incentive) {
        incentive.terms.forEach(function (leaseTerm) {
          if (leaseTerm.term == setTerms.from) {
            totalLeaseIncentives += leaseTerm.amount;
          }
        });
      });
    }

    let calcInputs = {
      price: price - totalLeaseIncentives,
      down: 0,
      term: setTerms.from,
      rate: setTerms.value,
      tradein: 0,
      tax: 0,
      residual: residualAmount,
    };

    if (disclaimerDetails.adjustPayments) {
      calcInputs.tax = parseInt(disclaimerDetails.tax);
    }

    const newCalc = PaymentCalculatorFactory.createCalculator('lease', calcInputs);
    newCalc.calculate();
    const finalPayment = newCalc.payments[FREQUENCY];

    if ($elem) {
      $payment.text(formatSrpPrice(finalPayment));
      showElem($elem);
    } else {
      return finalPayment;
    }

  } else {
    if($elem) {
      $elem
      .parents('.nasapi-vehicle-card')
      .find('.dsp-lease')
      .each(function () {
        showElem($(this));
      });
    } else {
      return false;
    }
  }
}

function showElem($elem) {
  $elem.each(function () {
    $(this).removeClass('hidden');
  });
}

document.addEventListener('DOMContentLoaded', runNasapi);
